import { useState } from "react"
import Content from "../../../components/Content"

const SecondDivisionPage = () => {
    const [teams] = useState(new Array(20).fill(""))

    return (
        <Content className="flex flex-col gap-5">
            <div className="flex items-center gap-5">
                <p className="flex items-center gap-5 text-zinc-700"><span className="min-w-2 max-w-2 min-h-2 max-h-2 bg-orange-400"></span> Mata Mata por el ascenso</p>
                <p className="flex items-center gap-5 text-zinc-700"><span className="min-w-2 max-w-2 min-h-2 max-h-2 bg-red-500"></span> Descenso directo</p>
            </div>
            <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="w-[50px] p-3">
                                #
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Equipo
                            </th>
                            <th scope="col" className="px-6 py-3">
                                PG
                            </th>
                            <th scope="col" className="px-6 py-3">
                                PP
                            </th>
                            <th scope="col" className="px-6 py-3">
                                PE
                            </th>
                            <th scope="col" className="px-6 py-3">
                                GF
                            </th>
                            <th scope="col" className="px-6 py-3">
                                GC
                            </th>
                            <th scope="col" className="px-6 py-3">
                                DG
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Pts
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {teams.map((stats, index) => (
                            <tr key={index} className="bg-white border-b">
                                <td className={`text-center px-6 py-4 border-l-4 ${index + 1 >= 1 && index + 1 <= 8 ? "border-l-orange-400" : ""} ${index + 1 >= 17 ? "border-l-red-500" : ""}`}>
                                    {index + 1}
                                </td>
                                <th scope="row" className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    Equipo {index + 1}
                                </th>

                                <td className="px-6 py-4">
                                    0
                                </td>

                                <td className="px-6 py-4">
                                    0
                                </td>
                                <td className="px-6 py-4">
                                    0
                                </td>
                                <td className="px-6 py-4">
                                    0
                                </td>
                                <td className="px-6 py-4">
                                    0
                                </td>
                                <td className="px-6 py-4">
                                    0
                                </td>
                                <td className="px-6 py-4">
                                    0
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Content>
    )
}

export default SecondDivisionPage